import { createReducer } from 'redux-starter-kit';

import { ProductsReducerType } from './products.types';
import {
  SET_PRODUCTS,
  CLEAR_PRODUCTS,
  SET_PRODUCT,
  CLEAR_PRODUCT,
} from './products.actions';

const initialState: ProductsReducerType = {
  list: {
    count: -1,
    next: '',
    previous: '',
    results: [],
  },
  selected: {
    name: '',
    slug: '',
    description: '',
    template: '',
    briefing_template: {
      id: -1,
      name: '',
      json: {},
    },
    workbench_id: -1,
    workbench: {
      id: -1,
      name: '',
      slug: '',
      icon: '',
      icon_url: '',
      active: false,
    },
    active: false,
    keywords: '',
    meta_description: '',
    title: '',
    subtitle: '',
    cta_text: '',
    data_collection_method: '',
  },
};

export default createReducer(initialState, {
  [SET_PRODUCTS]: (state, action) => {
    state.list = action.payload;
  },
  [CLEAR_PRODUCTS]: (state) => {
    state.list = initialState.list;
  },
  [SET_PRODUCT]: (state, action) => {
    state.selected = action.payload;
  },
  [CLEAR_PRODUCT]: (state) => {
    state.selected = initialState.selected;
  },
});
